import { useQuasar } from 'quasar'

export default async ({ next, to }) => {
  const $q = useQuasar()

  // Если пользователь на мобильном устройстве и находится на странице с сообщением,
  // перенаправляем его на главную
  if (to.meta?.isDesktopMessage && $q.platform.is.mobile) {
    return next('/')
  }

  // Пропускаем проверку для страницы с сообщением о десктопе
  if (to.meta?.isDesktopMessage) {
    return
  }

  // Если маршрут требует мобильное устройство и пользователь на десктопе
  if (to.meta?.requiresMobile && !$q.platform.is.mobile) {
    return next('/desktop-message')
  }
}
